import { TransportDamageEffect } from "./transport-damage.effect";

export const effects: any[] = [
  TransportDamageEffect
];
